import djs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";
import timezone from "dayjs/plugin/timezone";
import { MIN_YEAR_LIMIT, MAX_YEAR_LIMIT } from "@/constants/datetime";

djs.extend(isBetween);
djs.extend(customParseFormat);
djs.extend(isSameOrBefore);
djs.extend(isSameOrAfter);
djs.extend(utc);
djs.extend(duration);
djs.extend(weekOfYear);
djs.extend(timezone);
djs.tz.setDefault("Asia/Tokyo");

export const today = () => djs().set("h", 0).set("m", 0).set("s", 0).set("ms", 0);

export const hasInvalidDate = (...dates: (djs.Dayjs | string | null | undefined)[]): boolean => {
  const hasInvalid = dates.some((date) => {
    if (!date) return false;
    const d = djs(date);
    return !d.isValid() || d.year() < MIN_YEAR_LIMIT || d.year() > MAX_YEAR_LIMIT;
  });
  if (hasInvalid) return true;

  if (dates.length >= 2) {
    const from = dates[0] ? djs(dates[0]) : null;
    const to = dates[1] ? djs(dates[1]) : null;
    if (from && from.isValid() && to && to.isValid()) {
      return from.isAfter(to);
    }
  }

  return false;
};

export const dayjs = djs;
